import React, { useState, useEffect } from "react";
import { navigate } from "gatsby";

import DesktopFooter from "./desktop-footer";
import MobileFooter from "./mobile-footer";
import { LINKS } from "./constants";

const handleNavLinkClick = props => item => () => {
  const { onGalleryClick, onFilmClick } = props;

  if (item && item.link) {
    if (item.link === "/gallery") onGalleryClick && onGalleryClick();
    else if (item.link === "/film") onFilmClick && onFilmClick();
    else navigate(item.link, { state: { fromNavbar: false }, replace: true });
  }
};

const Footer = props => {
  const { isDesktop } = props;

  const [hasMounted, setHasMounted] = useState(false);

  // Did mount
  useEffect(() => {
    if (!hasMounted) setHasMounted(true);
  }, []); // eslint-disable-line

  // Initial render for SEO
  if (!hasMounted)
    return (
      <ul style={{ visibility: "hidden" }}>
        {LINKS.map(item => (
          <li key={`footer-link-${item.link}`} href={item.link}>
            {item.label}
          </li>
        ))}
      </ul>
    );

  return isDesktop ? (
    <DesktopFooter {...props} onNavLinkClick={handleNavLinkClick(props)} />
  ) : (
    <MobileFooter {...props} onNavLinkClick={handleNavLinkClick(props)} />
  );
};

export default Footer;
